var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "#F4F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5233 79.6221C38.5233 79.6221 46.662 97.063 36.462 98.9885C26.262 100.914 23.6568 89.3567 23.6568 89.3567L19.9678 91.7529C19.9678 91.7529 23.9968 105.095 35.221 105.082C46.4453 105.069 54.04 101.38 53.8233 89.3567C53.6065 77.3329 38.5233 79.6221 38.5233 79.6221Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M38.5233 79.6221C38.5233 79.6221 46.662 97.063 36.462 98.9885C26.262 100.914 23.6568 89.3567 23.6568 89.3567L19.9678 91.7529C19.9678 91.7529 23.9968 105.095 35.221 105.082C46.4453 105.069 54.04 101.38 53.8233 89.3567C53.6065 77.3329 38.5233 79.6221 38.5233 79.6221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5806 54.2224L47.3463 55.2451L42.4971 57.2776C42.4971 57.2776 32.3353 66.0665 36.0286 75.4074C39.7218 84.7483 56.3733 93.503 56.3733 93.503L62.9608 84.8681L50.5806 54.2224Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7765 69.2414L21.7018 74.1066L23.7375 69.2414L19.7765 69.2414Z",
    fill: "#335C75"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.163 29.888L50.5804 29.888L50.5804 121.484L120.163 121.484L120.163 29.888Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M83.0845 84.3247C93.208 84.3247 101.415 80.7997 101.415 76.4515C101.415 72.1032 93.208 68.5782 83.0845 68.5782C72.961 68.5782 64.7543 72.1032 64.7543 76.4515C64.7543 80.7997 72.961 84.3247 83.0845 84.3247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7108 39.3745C60.0018 39.3745 61.0483 38.3208 61.0483 37.021C61.0483 35.7213 60.0018 34.6676 58.7108 34.6676C57.4198 34.6676 56.3733 35.7213 56.3733 37.021C56.3733 38.3208 57.4198 39.3745 58.7108 39.3745Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3025 39.3745C66.5935 39.3745 67.64 38.3208 67.64 37.021C67.64 35.7213 66.5935 34.6676 65.3025 34.6676C64.0116 34.6676 62.965 35.7213 62.965 37.021C62.9651 38.3208 64.0116 39.3745 65.3025 39.3745Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6095 39.3745C72.9004 39.3745 73.947 38.3208 73.947 37.021C73.947 35.7213 72.9004 34.6676 71.6095 34.6676C70.3185 34.6676 69.272 35.7213 69.272 37.021C69.272 38.3208 70.3185 39.3745 71.6095 39.3745Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6123 57.0592L82.6213 48.925L68.6303 57.0592L68.6303 73.3234L82.6213 81.4576L96.6123 73.3234L96.6123 57.0592Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.012 92.951L67.9078 92.951C66.4689 92.951 65.3025 94.1253 65.3025 95.5739L65.3025 97.6364C65.3025 99.085 66.4689 100.259 67.9078 100.259L90.012 100.259C91.4509 100.259 92.6173 99.085 92.6173 97.6364L92.6173 95.5739C92.6173 94.1253 91.4509 92.951 90.012 92.951Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1417 102.925C98.6086 102.925 101.419 100.095 101.419 96.605C101.419 93.1146 98.6086 90.2851 95.1417 90.2851C91.6749 90.2851 88.8645 93.1146 88.8645 96.605C88.8645 100.095 91.6749 102.925 95.1417 102.925Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8638 96.7077L94.6318 99.0697L97.4878 94.5298",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M68.6303 57.0592L82.6213 65.1935L96.6123 57.0592L82.6213 48.925L68.6303 57.0592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M74.304 60.307L77.0325 61.8902L90.9767 53.7816L88.2482 52.1984L74.304 60.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M82.6212 65.1936L82.6212 81.4578L96.6122 73.3235L96.6122 57.0593L82.6212 65.1936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M80.1902 74.5686L80.1902 77.9147L77.3129 76.2416L77.3129 72.8998L80.1902 74.5686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M77.126 62.0058L77.126 66.8837L74.2488 65.2149L74.2488 60.337L77.126 62.0058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M91.1808 60.2342L88.4523 61.8174L74.508 53.7088L77.2365 52.1256L91.1808 60.2342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M88.3588 61.933L88.3588 66.811L91.2318 65.1422L91.2318 60.2642L88.3588 61.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6648 46.9868C37.6648 46.9868 38.3023 49.8365 39.3648 51.531C39.4662 51.6953 39.599 51.8377 39.7555 51.95C39.9119 52.0622 40.089 52.1422 40.2763 52.1852C40.4636 52.2281 40.6576 52.2333 40.8469 52.2003C41.0362 52.1674 41.2172 52.0969 41.3793 51.9931C42.2293 51.454 43.1983 50.4741 43.041 48.9037L43.0963 46.208C43.0519 45.6668 42.8416 45.153 42.4944 44.7375C42.1472 44.322 41.6803 44.0254 41.1583 43.8888C39.25 43.2641 37.1888 45.2709 37.6648 46.9868Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0707 46.6957L47.3462 55.245L42.497 57.2775L41.3325 50.2429L43.0707 46.6957Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 46.884C39.2638 46.6447 40.0968 46.3043 40.882 45.8699C40.7502 46.3303 40.7566 46.8197 40.9003 47.2765C41.0439 47.7333 41.3185 48.1371 41.6895 48.4372C42.0389 48.7334 42.4798 48.8979 42.9365 48.9025C43.3932 48.9072 43.8374 48.7518 44.1927 48.4629L43.0027 44.8986C42.8521 44.3841 42.566 43.9203 42.1746 43.5564C41.7833 43.1925 41.3013 42.9422 40.78 42.8319C40.3275 42.7323 39.8689 42.6637 39.4072 42.6265C38.2555 42.5409 36.9762 43.709 35.8415 43.3111C35.7271 43.2707 35.6042 43.2611 35.485 43.2831C35.3658 43.3051 35.2544 43.358 35.1617 43.4367C35.069 43.5153 34.9983 43.6169 34.9565 43.7314C34.9147 43.846 34.9033 43.9695 34.9235 44.0899C35.1062 45.2281 35.8415 46.8754 37.4735 46.9995C37.7867 47.0161 38.1003 46.977 38.4 46.884V46.884Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.375 48.4287C41.375 48.4287 41.0562 47.3504 41.8807 47.175C42.7052 46.9996 43.177 48.5571 42.1357 49.0492L41.375 48.4287Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1578 48.7495L37.7328 50.0674C37.7076 50.1423 37.7018 50.2224 37.7159 50.3001C37.73 50.3779 37.7634 50.4508 37.8131 50.5119C37.8628 50.5731 37.9272 50.6205 38.0001 50.6498C38.073 50.6791 38.1521 50.6892 38.23 50.6793L39.3478 50.5381L38.1578 48.7495Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M41.5237 51.792C42.0956 51.4356 42.5508 50.9178 42.8327 50.3029C42.8327 50.3029 43.2917 52.0145 41.9827 54.2224L41.5237 51.792Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1425 89.6904C23.1425 89.6904 21.9907 85.4756 19.9677 84.9836C17.9447 84.4915 20.6605 91.3207 20.6605 91.3207L23.1425 89.6904Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6589 79.9373L19.2156 81.1788L21.2249 88.4684L25.6682 87.227L23.6589 79.9373Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0573 58.9506L15.4568 58.9506C14.3522 58.9506 13.4568 59.8461 13.4568 60.9506L13.4568 68.7476C13.4568 69.8522 14.3522 70.7476 15.4568 70.7476L28.0573 70.7476C29.1618 70.7476 30.0573 69.8522 30.0573 68.7476L30.0573 60.9506C30.0573 59.8461 29.1618 58.9506 28.0573 58.9506Z",
    fill: "#335C75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.2707 64.1881L21.383 67.1876L24.5705 62.5107",
    stroke: "#F4F9FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 118.5C27.9675 118.5 2 92.5325 2 60.5H0C0 93.6371 26.8629 120.5 60 120.5V118.5ZM118 60.5C118 92.5325 92.0325 118.5 60 118.5V120.5C93.1371 120.5 120 93.6371 120 60.5H118ZM60 2.5C92.0325 2.5 118 28.4675 118 60.5H120C120 27.3629 93.1371 0.5 60 0.5V2.5ZM60 0.5C26.8629 0.5 0 27.3629 0 60.5H2C2 28.4675 27.9675 2.5 60 2.5V0.5Z",
    fill: "#E6F2FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_115",
    x: 7.77652,
    y: 58.2414,
    width: 27.961,
    height: 28.8651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0820513 0 0 0 0 0.16 0 0 0 0 0.32 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_115",
    x: 38.5804,
    y: 18.888,
    width: 93.583,
    height: 115.596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0820513 0 0 0 0 0.16 0 0 0 0 0.32 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_115",
    x: 1.45675,
    y: 47.9506,
    width: 40.6005,
    height: 35.797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0820513 0 0 0 0 0.16 0 0 0 0 0.32 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_115"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_115",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePayment);
export default __webpack_public_path__ + "static/media/MakePayment.930fcb7004ef9606ee62c75acae4c4ef.svg";
export { ForwardRef as ReactComponent };